import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ScanSearch, ArrowUpRight } from "lucide-react";
import { DpiChecker } from "./DpiChecker";
import { toolsForProduct } from "./registry";
import { ToolContext } from "./_ui";

// Collapsible helper under the artwork uploader: DPI check first, then any size tool for this product.
export function ProductTools({ product, configWidthIn, configHeightIn, onApplySize }) {
  const [open, setOpen] = useState(null);
  const extra = toolsForProduct(product);
  const items = [
    { id: "dpi-checker", icon: ScanSearch, label: "Not sure your file is sharp enough? Check its resolution", C: () => <DpiChecker initialW={configWidthIn} initialH={configHeightIn} /> },
    ...extra.map((t) => ({ id: t.id, icon: t.icon, label: t.h, C: t.C })),
  ];
  return (
    <ToolContext.Provider value={{ tool: null, onApplySize }}>
    <div className="mt-4 border border-slate-200 divide-y divide-slate-200" data-testid="product-tools">
      {items.map(({ id, icon: Icon, label, C }) => (
        <div key={id}>
          <button type="button" onClick={() => setOpen(open === id ? null : id)} className="w-full flex items-center gap-2 px-3 py-2.5 text-left text-sm font-bold text-kolt-slate-dark hover:bg-slate-50" data-testid={`product-tool-toggle-${id}`} aria-expanded={open === id}>
            <Icon className="w-4 h-4 text-[#B87333]" /> <span className="flex-1">{label}</span>
            <Link to={`/tools/${id}`} onClick={(e) => e.stopPropagation()} className="hidden sm:inline-flex items-center gap-1 font-mono text-[10px] tracking-widest uppercase text-slate-500 hover:text-kolt-orange" data-testid={`product-tool-open-${id}`}>Open tool <ArrowUpRight className="w-3 h-3" /></Link>
            <ChevronDown className={`w-4 h-4 transition-transform ${open === id ? "rotate-180" : ""}`} />
          </button>
          {open === id && <div className="px-3 pb-3" data-testid={`product-tool-body-${id}`}><C /></div>}
        </div>
      ))}
    </div>
    </ToolContext.Provider>
  );
}
